var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30 4v7a1 1 0 1 1-2 0V5a1 1 0 0 0-1-1h-6a1 1 0 1 1 0-2h7a2 2 0 0 1 2 2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m18.293 12.293 9.5-9.5 1.414 1.414-9.5 9.5a1 1 0 0 1-1.414-1.414",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 28v-7a1 1 0 1 1 2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 1 0 2H4a2 2 0 0 1-2-2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.707 18.293a1 1 0 0 1 0 1.414l-9.5 9.5-1.414-1.414 9.5-9.5a1 1 0 0 1 1.414 0",
  clipRule: "evenodd"
})));
export default SvgGrow;